import { gql } from '@apollo/client';

export const GET_CARE_TEAMS = gql`
  query GetCareTeams(
    $page: Int!
    $perPage: Int!
    $filter: FilterFindManyCareTeam
  ) {
    orgUnit {
      careTeamPagination(page: $page, perPage: $perPage, filter: $filter) {
        items {
          id
          subOrganizations {
            id
            name
            location {
              id
              name
            }
          }
          name
          practitionerIds
          patientIds
          tags
        }
        pageInfo {
          totalPages
          totalItems
          page
          perPage
          hasNextPage
        }
      }
    }
  }
`;
